import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import RevitParameterTemplate from "./RevitParameterTemplate.graphql";

export default function useRevitParameterTemplate(id: string) {
    return useQuery(
        gql(RevitParameterTemplate),
        {
            variables: {
                id,
            },
        },
    );
}
